import { useApi } from "@utils/useApi";
import { ProjectClient, ProjectDetailRequest } from "@lib/ShiOneClient";
import { useQuery } from "@tanstack/react-query";
import type { ProjectDetail } from "shared-ui/src/features/projects-feature/canonical";
import { mapToProjectDetail } from "../toCanonical";

const useGetProjectDetail = (request: ProjectDetailRequest) => {
  const api = useApi(ProjectClient);

  const getProjectDetail = async (): Promise<ProjectDetail> => {
    const response = await api.getProjectDetail(request);
    return mapToProjectDetail(response);
  };

  return useQuery<ProjectDetail, Error>({
    queryKey: [
      "project-detail",
      request.projectId,
      request.includeFilters,
      request.excludeFilters,
      request.groupBy,
      request.sortBy,
    ],
    queryFn: getProjectDetail,
    enabled: !!request.projectId && !isNaN(request.projectId) && request.projectId > 0,
  });
};

export default useGetProjectDetail;
